<script setup lang="ts">
	import { useAuthStore } from '@/stores/auth.ts';
	import { useRoute, useRouter } from 'vue-router';
	import { MzButton, MzTitle } from '@monizze/monizze-components';
	import { useI18n } from 'vue-i18n';
	import ItsmeButton from '@/components/ItsmeButton.vue';
	import { onBeforeMount, ref } from 'vue';
	import { Api } from '@/utils/api.ts';
	import Cookies from 'js-cookie';
	import getAppName from '@/utils/appName.ts';

	const { t } = useI18n();
	const route = useRoute();
	const router = useRouter();
	const authStore = useAuthStore();
	const { code, state } = route.query;

	const status = ref<'default' | 'processing'>('default');

	onBeforeMount(async () => {
		if (!code || !state) {
			return;
		}
		status.value = 'processing';
		try {
			if (!localStorage.getItem('itsme-state')) {
				const url = new URL(`${getAppName()}:///auth/itsme`);
				url.search = new URLSearchParams({
					code: code as string,
					state: state as string,
				}).toString();

				window.location.href = url.toString();
				return;
			}
			if (state !== localStorage.getItem('itsme-state')) {
				throw null;
			}
			const response = await Api.post('/itsme', {
				code: code as string,
				nonce: Cookies.get('itsme_nonce'),
				client_id: import.meta.env.VITE_OAUTH_API_CLIENT_ID_PASSWORD_GRANT,
				redirect_uri: import.meta.env.VITE_BE_URL + '/account-locked',
			});

			const data = await response.json();

			await authStore.loginByToken(data.access_token);
			sessionStorage.setItem('is_recovery', '1');
			router.replace({ name: 'setup-mfa' });
		} catch {
			router.replace('/login');
		} finally {
			localStorage.removeItem('itsme-state');
			Cookies.remove('itsme_nonce');
		}
	});
</script>

<template>
	<div class="flex flex-col gap-10">
		<mz-title class="self-center" type="h2" :text="t('itsme_forced.title')" />
		<div class="flex flex-col gap-6 items-center">
			<img class="w-76 h-76" src="/Mfa/MFA_Banner.svg" alt="" />
			<i18n-t keypath="itsme_forced.description" tag="p" class="w-full">
				<template #br>
					<br />
					<br />
				</template>
			</i18n-t>
		</div>
		<div class="flex flex-col gap-2 w-full">
			<itsme-button :is-loading="status === 'processing'" redirect-uri="/account-locked" />
			<mz-button variant="outline" size="large" :label="t('itsme_forced.no_itsme')" @click="router.replace({ name: 'need-help' })" />
		</div>
	</div>
</template>
